import { useFieldArray } from 'react-hook-form'
import type { UseFormReturn } from 'react-hook-form'
import { CardHeader, Button, Alert } from '@orientamos/ui'
import { Plus, Trash2, Building2 } from 'lucide-react'
import type { IntakeFormData } from '@orientamos/shared'
import { PartyForm } from '../PartyForm'

interface Step5Props {
  form: UseFormReturn<IntakeFormData>
}

export function Step5Owners({ form }: Step5Props) {
  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: 'owners',
  })

  const addOwner = () => {
    if (fields.length >= 2) return

    append({
      personType: 'natural',
      firstName: '',
      lastName: '',
      idNumber: '',
      idIssuedAt: '',
      profession: '',
      phone: '',
      address: '',
      city: 'Medellin',
      email: '',
      invoiceEmail: '',
      role: 'owner',
      sortOrder: fields.length,
      banking: {
        accountNumber: '',
        bankName: '',
        accountType: 'ahorros',
        accountHolderName: '',
        accountHolderId: '',
      },
      documents: null,
      dataAuthorizationAccepted: false,
      referenceCheckAuthorized: false,
    })
  }

  const canRemove = fields.length > 1

  return (
    <div className="space-y-8">
      <CardHeader
        title="Propietarios"
        description="Ingresa los datos de los propietarios del inmueble. Puedes agregar hasta 2 propietarios."
      />

      {fields.map((field, index) => (
        <div
          key={field.id}
          className="relative pt-6 pb-8 border-t border-neutral-200 first:border-t-0 first:pt-0"
        >
          {canRemove && (
            <div className="absolute top-6 right-0 first:top-0">
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => remove(index)}
                className="text-danger-600 hover:text-danger-700 hover:bg-danger-50"
              >
                <Trash2 className="w-4 h-4 mr-1" />
                Eliminar
              </Button>
            </div>
          )}

          <div className="flex items-center gap-2 mb-4">
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-secondary-100 text-secondary-700">
              <Building2 className="w-4 h-4" />
            </div>
            <span className="font-medium text-neutral-900">Propietario {index + 1}</span>
          </div>

          <PartyForm
            form={form}
            basePath={`owners.${index}`}
            title=""
            description=""
            showBanking={true}
            personTypeToggle={true}
          />
        </div>
      ))}

      {fields.length < 2 && (
        <div className="pt-4">
          <Button type="button" variant="outline" onClick={addOwner}>
            <Plus className="w-4 h-4 mr-1" />
            Agregar Propietario
          </Button>
        </div>
      )}

      {fields.length >= 2 && (
        <Alert variant="info">Has alcanzado el maximo de 2 propietarios permitidos.</Alert>
      )}
    </div>
  )
}
